
export class BaseModel {
    constructor(data) {
        for (let key of Object.keys(data || {})) {
            if (data[key] !== null) {
                this[key] = data[key];
            }
        }
    }
}